import { css } from "@emotion/css";
import { AriaCheckboxGroupProps, useCheckboxGroup } from "react-aria";
import { useCheckboxGroupState } from "react-stately";

import { AccessibilityWarnings } from "../../../../components/inputs/AccessibilityWarnings";
import { FieldErrorsProps } from "../../../../components/inputs/_assets/input-wrapper/FieldErrors";
import { FormFeedback } from "../../../../components/inputs/_assets/input-wrapper/FormFeedback";
import { FormLabel } from "../../../../components/inputs/_assets/input-wrapper/FormLabel";
import { FormText } from "../../../../components/inputs/_assets/input-wrapper/FormText";
import { CheckboxContext } from "../context";

export interface CheckboxGroupProps extends AriaCheckboxGroupProps {
  direction?: "column" | "row";
  children: React.ReactNode;
  errors?: FieldErrorsProps["children"];
  testID?: string;
}

/**
 * @deprecated see CheckboxGroupRAC
 */
export function CheckboxGroup(props: CheckboxGroupProps) {
  const state = useCheckboxGroupState(props);
  const { groupProps, labelProps, descriptionProps, errorMessageProps } =
    useCheckboxGroup(props, state);
  const {
    children,
    label,
    description,
    errors,
    testID = "checkbox-group",
    direction = "column",
  } = props;

  return (
    <div {...groupProps} data-testid={testID}>
      <FormLabel {...labelProps} isRequired={props.isRequired}>
        {label}
      </FormLabel>
      <CheckboxContext.Provider value={state}>
        <div
          className={css(styles.container, {
            flexDirection: direction,
            marginTop: label ? "var(--space-2)" : undefined,
            gap: direction === "column" ? "var(--space-2)" : "var(--space-6)",
          })}
        >
          {children}
        </div>
      </CheckboxContext.Provider>
      <FormText {...descriptionProps}>{description}</FormText>
      <FormFeedback {...errorMessageProps}>{errors}</FormFeedback>
      <AccessibilityWarnings labelProps={props} />
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
  }),
};
